import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { qualityNcrAPI } from '@/lib/api';

export const MapCustomerDialog = ({ complaint, open, onClose, onMapped }) => {
  const [options, setOptions] = useState([]);
  const [cid, setCid] = useState('');
  const [all, setAll] = useState(true);
  const [saving, setSaving] = useState(false);
  const original = complaint.legacy_customer_name || complaint.customer_name;
  useEffect(() => {
    if (!open) return;
    setCid(complaint.customer_id || ''); setAll(true);
    qualityNcrAPI.customerOptions().then((r) => setOptions(r.data)).catch(() => toast.error('Failed to load customers'));
  }, [open, complaint.customer_id]);
  const save = async () => {
    setSaving(true);
    try {
      const r = (await qualityNcrAPI.mapComplaintCustomer(complaint.id, { customer_id: cid, apply_to_same_name: all })).data;
      toast.success(`Mapped to ${r.customer_name} (${r.updated} complaint${r.updated === 1 ? '' : 's'})`); onMapped();
    } catch (e) { toast.error(e.response?.data?.detail || 'Failed to map'); } finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="map-customer-dialog">
        <DialogHeader>
          <DialogTitle>Map to a system customer</DialogTitle>
          <DialogDescription>Old register name: <b className="whitespace-pre-line">{original}</b></DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><Label className="text-xs">Customer</Label>
            <Select value={cid} onValueChange={setCid}>
              <SelectTrigger data-testid="map-customer-select"><SelectValue placeholder="Select customer" /></SelectTrigger>
              <SelectContent>{options.map((o) => <SelectItem key={o.id} value={o.id} data-testid={`map-customer-option-${o.id}`}>{o.customer_name}{o.customer_code ? ` (${o.customer_code})` : ''}</SelectItem>)}</SelectContent>
            </Select></div>
          <label className="flex items-center gap-2 text-xs"><Checkbox checked={all} onCheckedChange={(v) => setAll(!!v)} data-testid="map-customer-all-checkbox" />
            Also update every other imported complaint named “{original.replace(/\n/g, ' ')}”</label>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="map-customer-cancel-btn">Cancel</Button>
          <Button onClick={save} disabled={!cid || saving} data-testid="map-customer-save-btn">{saving && <Loader2 className="w-4 h-4 mr-1 animate-spin" />}Map customer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
